import React from 'react'
import api from 'src/services/api'

const useChangePasswordHistory = () => {
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [data, setData] = React.useState<any[]>([])


    const fetchData = async () => {
        setLoading(true)
        setError(null)
        try {
            const response = await api.get('/accounts/password/change') 
            setData(response.data.passwordChanges || [])
        } catch (e: any) {
            setError(e?.message || 'Error')
            setData([])
        } finally {
            setLoading(false)
        }
    }
    return { data, loading, error, fetchData }

}

export default useChangePasswordHistory